<template>
    <div class="container">
        <div class="header-container" :style="{ backgroundImage: `url('/Static/images/calculator.png')`}">
            <div class="center-text">
                <h1>{{ texts[selectedLanguage.code].title }}</h1>
                <p>{{ texts[selectedLanguage.code].subtitle }}</p>
            </div>
            <div class="language-wrapper" v-show="languages?.length">
                <Dropdown autoOptionFocus
                          :tabindex="3"
                          v-model="selectedLanguage"
                          inputId="languageSelection"
                          :options="languages"
                          option-label="name"
                          append-to="self"
                          class="w-full md:w-14rem language-menu"
                          placeholder=" "
                          scrollheight="500px">
                    <template #value="slotProps">
                        <div v-if="slotProps.value" class="d-flex flex-row align-items-center">
                            <country-flag class="flag-icon rounded-lg"
                                          :country="mapLanguageToCountryCode(slotProps.value.code)"
                                          size="normal" />
                            <div>{{ slotProps.value.name }}</div>
                        </div>
                    </template>
                    <template #option="slotProps">
                        <div class="d-flex flex-row align-items-center">
                            <country-flag class="rounded-lg mr-1 my-0"
                                          :country="mapLanguageToCountryCode(slotProps.option.code)"
                                          size="normal" />
                            <div>{{ slotProps.option.name }}</div>
                        </div>
                    </template>
                </Dropdown>
            </div>
        </div>
        <form>
            <section>
                <div class="d-flex gap-1 justify-content-between">
                    <div class="form-group" style="flex:3">
                        <label style="width:685px" for="tierSelection">{{ texts[selectedLanguage.code].dropdown.tier.name }}</label>
                        <Dropdown autoOptionFocus :tabindex="1" v-model="selectedTier" inputId="tierSelection" :options="tiers" optionLabel="name" optionValue="code" class="w-full md:w-14rem" />
                    </div>
                    <div class="form-group align-items-end" style="flex:1">
                        <label class="label-inputswitch-lineheight" for="showQP">{{ texts[selectedLanguage.code].headers.qpc }}</label>
                        <InputSwitch inputId="showQP" v-model="showQP" />
                    </div>
                    <div class="form-group align-items-end" style="flex:1">
                        <label class="label-inputswitch-lineheight" for="showFee">{{ texts[selectedLanguage.code].toggle.fee.name }}</label>
                        <InputSwitch inputId="showFee" v-model="showFee" />
                    </div>
                    <div v-if="isCadacSales()" class="form-group align-items-end" style="flex:1">
                        <label class="label-inputswitch-lineheight" for="showCadac">
                            {{ texts[selectedLanguage.code].toggle.cadac.name }}
                        </label>
                        <InputSwitch inputId="showCadac" v-model="showCadac" />
                    </div>
                </div>
                <h1>New Business</h1>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenue }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenueGr1 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenueGr2 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.standard }}
                                <!--<PopoverIcon class="d-inline-flex ml-0">
                        <i class="popover-icon pi pi-info-circle" />
                        <template #content>
                            <div>
                                ({{data.ltFamily[selectedTier].ppc.percentage}}/{{data.autocadIST[selectedTier].ppc.percentage}}/{{data.verticals[selectedTier].ppc.percentage}}/{{data.cadacIP[selectedTier].ppc.percentage}}/{{data.cadacServices[selectedTier].ppc.percentage.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}})%
                            </div>
                        </template>
                    </PopoverIcon>-->
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.growth1 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.growth2 }}
                            </th>
                            <th v-if="showQP">
                                {{ texts[selectedLanguage.code].headers.qpc }}
                            </th>
                            <th v-if="showFee">
                                {{ texts[selectedLanguage.code].headers.fee }}
                            </th>
                            <th v-if="isCadacSales() && showCadac">
                                {{ texts[selectedLanguage.code].headers.cadac }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{data.ltFamily.name}}</td>
                            <td><InputNumber v-model="inputs.ltFamily" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.ltFamilyGr1" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.ltFamilyGr2" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td>
                                <InputNumber :modelValue="computedValues.ltFamily.ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td>
                                <InputNumber :modelValue="computedValues.ltFamily.gr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td>
                                <InputNumber :modelValue="computedValues.ltFamily.gr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td v-if="showQP"><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.ltFamily.fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.ltFamily.cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.autocadIST.name}}</td>
                            <td><InputNumber v-model="inputs.autocadIST" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.autocadISTGr1" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.autocadISTGr2" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST.ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST.gr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST.gr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showQP"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST.qp" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST.fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST.cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>

                        </tr>
                        <tr>
                            <td>
                                {{data.autocadIST_cloud.name}}
                                <!--<PopoverIcon class="d-inline-flex ml-0">
                        <i class="popover-icon pi pi-info-circle" />
                        <template #content>
                            <div>
                                15% of NEW AutoCAD IST or Vertical (Incl. IC & ACS/Make)
                            </div>
                        </template>
                    </PopoverIcon>-->
                            </td>
                            <td><InputNumber v-model="inputs.autocadIST_cloud" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.autocadIST_cloudGr1" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.autocadIST_cloudGr2" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST_cloud.ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST_cloud.gr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST_cloud.gr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showQP"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST_cloud.qp" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST_cloud.fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST_cloud.cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.verticals.name}}</td>
                            <td><InputNumber v-model="inputs.verticals" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.verticalsGr1" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.verticalsGr2" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals.ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals.gr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals.gr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showQP"><div class="highlight"><InputNumber :modelValue="computedValues.verticals.qp" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.verticals.fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.verticals.cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>

                        </tr>
                        <tr>
                            <td>
                                {{data.verticals_cloud.name}}
                                <!--<PopoverIcon class="d-inline-flex ml-0">
                        <i class="popover-icon pi pi-info-circle" />
                        <template #content>
                            <div>
                                25% of NEW AutoCAD IST or Vertical (Incl. IC & ACS/Make)
                            </div>
                        </template>
                    </PopoverIcon>-->
                            </td>
                            <td><InputNumber v-model="inputs.verticals_cloud" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.verticals_cloudGr1" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.verticals_cloudGr2" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals_cloud.ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals_cloud.gr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals_cloud.gr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showQP"><div class="highlight"><InputNumber :modelValue="computedValues.verticals_cloud.qp" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.verticals_cloud.fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.verticals_cloud.cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.cadacIP.name}}</td>
                            <td><InputNumber v-model="inputs.cadacIP" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputNumber :modelValue="computedValues.cadacIP.ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showQP"><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showFee"><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.cadacIP.cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>

                        </tr>
                        <tr>
                            <td>{{data.cadacServices.name}}</td>
                            <td><InputNumber v-model="inputs.cadacServices" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputNumber :modelValue="computedValues.cadacServices.ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showQP"><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showFee"><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.cadacServices.cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr class="border-top">
                            <td>{{ texts[selectedLanguage.code].total }}</td>
                            <td><InputNumber :modelValue="computedValues.totalRevenue" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.totalRevenueGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.totalRevenueGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.totalPpc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.totalGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.totalGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showQP"><div class="highlight"><InputNumber :modelValue="totals.totalQP" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="totals.totalFee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="totals.totalCadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>

                    </tbody>
                </table>

                <!-- #region Renew excl txc -->
                <div class="mt-4"></div>
                <h1>Renew excl txc</h1>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenue }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenueGr1 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenueGr2 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.standard }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.growth1 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.growth2 }}
                            </th>
                            <th v-if="isCadacSales() && showCadac">
                                {{ texts[selectedLanguage.code].headers.cadac }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{data.ltFamily.name}}</td>
                            <td><InputNumber v-model="inputs.renew_ltFamily" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.renew_ltFamilyGr1" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.renew_ltFamilyGr2" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td>
                                <InputNumber :modelValue="computedValues.ltFamily.renew_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td>
                                <InputNumber :modelValue="computedValues.ltFamily.renew_gr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td>
                                <InputNumber :modelValue="computedValues.ltFamily.renew_gr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.ltFamily.renew_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.autocadIST.renew_name}}</td>
                            <td><InputNumber v-model="inputs.renew_autocadIST" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.renew_autocadISTGr1" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.renew_autocadISTGr2" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST.renew_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST.renew_gr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST.renew_gr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST.renew_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.verticals.renew_name}}</td>
                            <td><InputNumber v-model="inputs.renew_verticals" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.renew_verticalsGr1" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.renew_verticalsGr2" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals.renew_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals.renew_gr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals.renew_gr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.verticals.renew_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.cadacIP.name}}</td>
                            <td><InputNumber v-model="inputs.renew_cadacIP" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputNumber :modelValue="computedValues.cadacIP.renew_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.cadacIP.renew_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>

                        </tr>
                        <tr>
                            <td>{{data.cadacServices.name}}</td>
                            <td><InputNumber v-model="inputs.renew_cadacServices" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputNumber :modelValue="computedValues.cadacServices.renew_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.cadacServices.renew_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr class="border-top">
                            <td>{{ texts[selectedLanguage.code].total }}</td>
                            <td><InputNumber :modelValue="computedValues.renew_totalRevenue" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.renew_totalRevenueGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.renew_totalRevenueGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.renew_totalPpc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.renew_totalGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.renew_totalGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="isCadacSales() && showCadac">
                                <div class="highlight">
                                    <InputNumber :modelValue="totals.renew_totalCadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- #endregion -->
                <!-- #region Renew incl txc -->
                <div class="mt-4"></div>
                <h1>Renew incl txc</h1>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenue }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenueGr1 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenueGr2 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.standard }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.growth1 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.growth2 }}
                            </th>
                            <th v-if="showFee">
                                {{ texts[selectedLanguage.code].headers.fee }}
                            </th>
                            <th v-if="isCadacSales() && showCadac">
                                {{ texts[selectedLanguage.code].headers.cadac }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{data.ltFamily.name}}</td>
                            <td><InputNumber v-model="inputs.renew_incl_ltFamily" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.renew_incl_ltFamilyGr1" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.renew_incl_ltFamilyGr2" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td>
                                <InputNumber :modelValue="computedValues.ltFamily.renew_incl_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td>
                                <InputNumber :modelValue="computedValues.ltFamily.renew_incl_gr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td>
                                <InputNumber :modelValue="computedValues.ltFamily.renew_incl_gr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.ltFamily.renew_incl_fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.ltFamily.renew_incl_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.autocadIST.renew_name}}</td>
                            <td><InputNumber v-model="inputs.renew_incl_autocadIST" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.renew_incl_autocadISTGr1" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.renew_incl_autocadISTGr2" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST.renew_incl_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST.renew_incl_gr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST.renew_incl_gr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST.renew_incl_fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST.renew_incl_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.verticals.renew_name}}</td>
                            <td><InputNumber v-model="inputs.renew_incl_verticals" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.renew_incl_verticalsGr1" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber v-model="inputs.renew_incl_verticalsGr2" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals.renew_incl_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals.renew_incl_gr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals.renew_incl_gr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.verticals.renew_incl_fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.verticals.renew_incl_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.cadacIP.name}}</td>
                            <td><InputNumber v-model="inputs.renew_incl_cadacIP" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputNumber :modelValue="computedValues.cadacIP.renew_incl_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showFee"><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.cadacIP.renew_incl_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>

                        </tr>
                        <tr>
                            <td>{{data.cadacServices.name}}</td>
                            <td><InputNumber v-model="inputs.renew_incl_cadacServices" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputNumber :modelValue="computedValues.cadacServices.renew_incl_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showFee"><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.cadacServices.renew_incl_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr class="border-top">
                            <td>{{ texts[selectedLanguage.code].total }}</td>
                            <td><InputNumber :modelValue="computedValues.renew_incl_totalRevenue" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.renew_incl_totalRevenueGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.renew_incl_totalRevenueGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.renew_incl_totalPpc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.renew_incl_totalGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.renew_incl_totalGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="totals.renew_incl_totalFee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac">
                                <div class="highlight">
                                    <InputNumber :modelValue="totals.renew_incl_totalCadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- #endregion -->
                <!-- #region Government excl GPI/CPI -->
                <div class="mt-4"></div>
                <h1>Government excl GPI/CPI</h1>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenue }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.standard }}
                            </th>
                            <th v-if="showFee">
                                {{ texts[selectedLanguage.code].headers.fee }}
                            </th>
                            <th v-if="isCadacSales() && showCadac">
                                {{ texts[selectedLanguage.code].headers.cadac }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{data.ltFamily.name}}</td>
                            <td><InputNumber v-model="inputs.gov_ltFamily" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td>
                                <InputNumber :modelValue="computedValues.ltFamily.gov_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.ltFamily.gov_fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.ltFamily.gov_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.autocadIST.renew_name}}</td>
                            <td><InputNumber v-model="inputs.gov_autocadIST" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST.gov_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST.gov_fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST.gov_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.verticals.renew_name}}</td>
                            <td><InputNumber v-model="inputs.gov_verticals" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals.gov_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.verticals.gov_fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.verticals.gov_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr class="border-top">
                            <td>{{ texts[selectedLanguage.code].total }}</td>
                            <td><InputNumber :modelValue="computedValues.gov_totalRevenue" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.gov_totalPpc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="totals.gov_totalFee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac">
                                <div class="highlight">
                                    <InputNumber :modelValue="totals.gov_totalCadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- #endregion -->
                <!-- #region Government incl GPI/CPI -->
                <div class="mt-4"></div>
                <h1>Government incl GPI/CPI</h1>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenue }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.standard }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.cpi }}                                
                            </th>
                            <th v-if="showFee">
                                {{ texts[selectedLanguage.code].headers.fee }}
                            </th>
                            <th v-if="isCadacSales() && showCadac">
                                {{ texts[selectedLanguage.code].headers.cadac }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{data.ltFamily.name}}</td>
                            <td><InputNumber v-model="inputs.gov_incl_ltFamily" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td>
                                <InputNumber :modelValue="computedValues.ltFamily.gov_incl_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td>
                                <InputNumber :modelValue="computedValues.ltFamily.gov_incl_cpi" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.ltFamily.gov_incl_fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.ltFamily.gov_incl_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.autocadIST.renew_name}}</td>
                            <td><InputNumber v-model="inputs.gov_incl_autocadIST" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.autocadIST.gov_incl_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td>
                                <InputNumber :modelValue="computedValues.autocadIST.gov_incl_cpi" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST.gov_incl_fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.autocadIST.gov_incl_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{data.verticals.renew_name}}</td>
                            <td><InputNumber v-model="inputs.gov_incl_verticals" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.verticals.gov_incl_ppc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td>
                                <InputNumber :modelValue="computedValues.verticals.gov_incl_cpi" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="computedValues.verticals.gov_incl_fee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="computedValues.verticals.gov_incl_cadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr class="border-top">
                            <td>{{ texts[selectedLanguage.code].total }}</td>
                            <td><InputNumber :modelValue="computedValues.gov_incl_totalRevenue" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.gov_incl_totalPpc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td>
                                <InputNumber :modelValue="totals.gov_incl_totalCpi" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                            </td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="totals.gov_incl_totalFee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac">
                                <div class="highlight">
                                    <InputNumber :modelValue="totals.gov_incl_totalCadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- #endregion -->
                <!-- #region total new + renew table -->
                <div class="mt-4"></div>
                <h1>Total New + Renew + Government</h1>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenue }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenueGr1 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.revenueGr2 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.standard }}

                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.growth1 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.growth2 }}
                            </th>
                            <th>
                                {{ texts[selectedLanguage.code].headers.cpi }}
                            </th>
                            <th v-if="showQP">
                                {{ texts[selectedLanguage.code].headers.qpc }}
                            </th>
                            <th v-if="showFee">
                                {{ texts[selectedLanguage.code].headers.fee }}
                            </th>
                            <th v-if="isCadacSales() && showCadac">
                                {{ texts[selectedLanguage.code].headers.cadac }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ texts[selectedLanguage.code].total_new }}</td>
                            <td><InputNumber :modelValue="computedValues.totalRevenue" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.totalRevenueGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.totalRevenueGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.totalPpc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.totalGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.totalGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showQP"><div class="highlight"><InputNumber :modelValue="totals.totalQP" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="totals.totalFee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="totals.totalCadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                        <tr>
                            <td>{{ texts[selectedLanguage.code].total_renew }}</td>
                            <td><InputNumber :modelValue="computedValues.renew_totalRevenue" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.renew_totalRevenueGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.renew_totalRevenueGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.renew_totalPpc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.renew_totalGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.renew_totalGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showQP"><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showFee"><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="isCadacSales() && showCadac">
                                <div class="highlight">
                                    <InputNumber :modelValue="totals.renew_totalCadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ texts[selectedLanguage.code].total_renew_incl }}</td>
                            <td><InputNumber :modelValue="computedValues.renew_incl_totalRevenue" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.renew_incl_totalRevenueGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="computedValues.renew_incl_totalRevenueGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.renew_incl_totalPpc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.renew_incl_totalGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="totals.renew_incl_totalGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showQP"><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="totals.renew_incl_totalFee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac">
                                <div class="highlight">
                                    <InputNumber :modelValue="totals.renew_incl_totalCadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ texts[selectedLanguage.code].total_gov }}</td>
                            <td><InputNumber :modelValue="computedValues.gov_totalRevenue" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputNumber :modelValue="totals.gov_totalPpc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showQP"><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="totals.gov_totalFee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac">
                                <div class="highlight">
                                    <InputNumber :modelValue="totals.gov_totalCadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ texts[selectedLanguage.code].total_gov_incl }}</td>
                            <td><InputNumber :modelValue="computedValues.gov_incl_totalRevenue" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputNumber :modelValue="totals.gov_incl_totalPpc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td><InputNumber :modelValue="totals.gov_incl_totalCpi" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showQP"><InputText class="bg-disabled" type="text" value="n.v.t" :disabled="true" /></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="totals.gov_incl_totalFee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac">
                                <div class="highlight">
                                    <InputNumber :modelValue="totals.gov_incl_totalCadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" />
                                </div>
                            </td>
                        </tr>
                        <tr class="border-top">
                            <td>{{ texts[selectedLanguage.code].total }}</td>
                            <td><InputNumber :modelValue="combinedTotals.combined_totalRevenue" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="combinedTotals.combined_totalRevenueGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="combinedTotals.combined_totalRevenueGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="combinedTotals.combined_totalPpc" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="combinedTotals.combined_totalGr1" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="combinedTotals.combined_totalGr2" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td><InputNumber :modelValue="combinedTotals.combined_totalCpi" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></td>
                            <td v-if="showQP"><div class="highlight"><InputNumber :modelValue="combinedTotals.combined_totalQP" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="showFee"><div class="highlight"><InputNumber :modelValue="combinedTotals.combined_totalFee" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                            <td v-if="isCadacSales() && showCadac"><div class="highlight"><InputNumber :modelValue="combinedTotals.combined_totalCadac" :disabled="true" mode="currency" currency="EUR" locale="nl-NL" /></div></td>
                        </tr>
                    </tbody>
                </table>
                <!-- #endregion -->
                <div class="mt-4">
                    <h4>{{ texts[selectedLanguage.code].disclaimer.title }}:</h4>
                    <p>{{ texts[selectedLanguage.code].disclaimer.p1 }}</p>
                    <p>{{ texts[selectedLanguage.code].disclaimer.p2 }}</p>
                    <p><small>{{ texts[selectedLanguage.code].disclaimer.small }}</small></p>
                </div>
            </section>
        </form>
    </div>
</template>

<script lang="ts">
    import BaseComponent from "@/components/base/baseComponent.vue";
    import { IAffiliatePartnerCalculatorPageViewModel } from "../../types/viewModels/commerce/affiliatePartnerCalculatorPageViewModel";
    import { Component, Prop } from "vue-facing-decorator";
    import { PropType, computed, ref, Ref } from "vue";
    import { LocationOptionViewModel } from "@/types/models/menu/locationOptionViewModel";

    @Component({
        components: {
            BaseComponent,
        },
    })
    export default class AffiliatePartnerCalculator extends BaseComponent {
        @Prop({ type: Object as PropType<IAffiliatePartnerCalculatorPageViewModel>, required: true, default: () => ({ form: {} }) })
        vm!: IAffiliatePartnerCalculatorPageViewModel;

        get mapLanguageToCountryCode() {
            return (lang: string) => (lang === "en" ? "gb" : lang);
        }

        showQP = ref(true);
        showFee = ref(true);
        showCadac = ref(false);
        selectedTier = ref('tier1');

        isCadacSales() {
            return (this.userProfile?.isCadacSales || this.userProfile?.isImpersonated);
        }

        texts = {
            en: {
                title: 'Affiliate program calculator',
                subtitle: 'Your entered data will not be stored',
                toggle: {
                    fee: {
                        name: 'Show transaction fee',
                    },
                    cadac: {
                        name: 'Show Cadac profit',
                    },
                },
                dropdown: {
                    tier: {
                        name: 'Select tier',
                        options: {
                            tier1: 'Tier 1: < \u20AC2.500.000 AOV year TO Partnersize',
                            tier2: 'Tier 2: \u20AC2.500.000 - \u20AC5,000,000 AOV year TO Partnersize',
                            tier3: 'Tier 3: > \u20AC5,000,000 AOV year TO Partnersize',
                        },
                    },
                    language: {
                        name: 'Select language',
                        options: {
                            1: 'NL',
                            2: 'EN',
                            3: 'DE',
                        },
                    },
                },
                headers: {
                    revenue: 'Expected revenue',
                    revenueGr1: 'Expected Growth 1',
                    revenueGr2: 'Expected Growth 2',
                    standard: 'Standard',
                    growth1: 'Growth 1',
                    growth2: 'Growth 2',
                    cpi: 'GPI / CPI',
                    qpc: 'Quarterly Performance Commission',
                    fee: 'Transaction fee',
                    cadac: 'Cadac profit',
                },
                total: 'Total',
                total_new: 'Total New',
                total_renew: 'Total Renew excl txc',
                total_renew_incl: 'Total Renew Incl txc',
                total_gov: 'Total Government excl GPI/CPI',
                total_gov_incl: 'Total Government incl GPI/CPI',

                disclaimer: {
                    title: 'Disclaimer',
                    p1: 'Please note that for any order where no Autodesk partner commission (PPC) is applicable - such as in cases involving No Eligible Product, No Specialization, Named Account restrictions, or Non-Nurture Reseller status - no partner reward will be granted.',
                    p2: 'We strongly aim to ensure a minimum margin/commission of on each order. However, this may not be guaranteed in situations where Autodesk does not provide any partner compensation.',
                    small: 'The results of this calculator are indicative and may differ from actual outcomes. No rights can be derived from this tool.',
                }
            },
            nl: {
                title: 'Affiliate programma calculator',
                subtitle: 'Uw ingevoerde gegevens worden niet opgeslagen',
                toggle: {
                    fee: {
                        name: 'Toon transactie fee',
                    },
                    cadac: {
                        name: 'Toon Cadac winst',
                    },
                },
                dropdown: {
                    tier: {
                        name: 'Selecteer tier',
                        options: {
                            tier1: 'Tier 1: < \u20AC2.500.000 jaarlijkse orderwaarde - Partneromvang op basis van omzet',
                            tier2: 'Tier 2: \u20AC2.500.000 - \u20AC5,000,000 jaarlijkse orderwaarde - Partneromvang op basis van omzet',
                            tier3: 'Tier 3: > \u20AC5,000,000 jaarlijkse orderwaarde - Partneromvang op basis van omzet',
                        },
                    },
                    language: {
                        name: 'Selecteer taal',
                        options: {
                            1: 'NL',
                            2: 'EN',
                            3: 'DE',
                        },
                    },
                },
                headers: {
                    revenue: 'Verwachte Standard',
                    revenueGr1: 'Verwachte Growth 1',
                    revenueGr2: 'Verwachte Growth 2',
                    standard: 'Standard',
                    growth1: 'Growth 1',
                    growth2: 'Growth 2',
                    cpi: 'GPI / CPI',
                    qpc: 'Quarterly Performance Commission',
                    fee: 'Transactie fee',
                    cadac: 'Cadac winst',
                },
                total: 'Totaal',
                total_new: 'Total New',
                total_renew: 'Total Renew excl txc',
                total_renew_incl: 'Total Renew Incl txc',
                total_gov: 'Total Government excl GPI/CPI',
                total_gov_incl: 'Total Government incl GPI/CPI',
                disclaimer: {
                    title: 'Disclaimer',
                    p1: 'Let op: voor elke bestelling waarbij geen Autodesk-partnercommissie (PPC) van toepassing is - zoals in gevallen met een niet-in aanmerking komend product, geen specialisatie, beperkingen voor Named Accounts of een Non-Nurture Reseller-status - wordt er geen partnerbeloning toegekend.',
                    p2: 'Wij streven er sterk naar om bij elke bestelling een minimale marge/commissie te waarborgen. Echter, in situaties waarin Autodesk geen partnervergoeding biedt, kunnen wij dit niet garanderen.',
                    small: 'De uitkomsten van deze calculator zijn indicatief en kunnen afwijken van de daadwerkelijke resultaten. Aan dit hulpmiddel kunnen geen rechten worden ontleend.'
                }
            },
            de: {
                title: 'Affiliate-Programm-Rechner',
                subtitle: 'Ihre eingegebene Daten werden nicht gespeichert',
                toggle: {
                    fee: {
                        name: 'Transaktionsgeb\u00FChr anzeigen',
                    },
                    cadac: {
                        name: 'Cadac-Gewinn anzeigen',
                    },
                },
                dropdown: {
                    tier: {
                        name: 'Stufe ausw\u00E4hlen',
                        options: {
                            tier1: 'Stufe 1: < \u20AC2.500.000 j\u00E4hrliches Auftragsvolumen - Partnergr\u00F6\u00DFe nach Umsatz',
                            tier2: 'Stufe 2: \u20AC2.500.000 - \u20AC5,000,000 j\u00E4hrliches Auftragsvolumen - Partnergr\u00F6\u00DFe nach Umsatz',
                            tier3: 'Stufe 3: > \u20AC5,000,000 j\u00E4hrliches Auftragsvolumen - Partnergr\u00F6\u00DFe nach Umsatz',
                        },
                    },
                    language: {
                        name: 'Sprache ausw\u00E4hlen',
                        options: {
                            1: 'NL',
                            2: 'EN',
                            3: 'DE',
                        },
                    },
                },
                headers: {
                    revenue: "Erwarteter Standard",
                    revenueGr1: 'Erwarteter Growth 1',
                    revenueGr2: 'Erwarteter Growth 2',
                    standard: "Standard",
                    growth1: "Growth 1",
                    growth2: "Growth 2",
                    cpi: 'GPI / CPI',
                    qpc: 'Quarterly Performance Commission',
                    fee: "Transaktionsgeb\u00FChr",
                    cadac: 'Cadac-Gewinn',
                },
                total: 'Gesamt',
                total_new: 'Total New',
                total_renew: 'Total Renew excl txc',
                total_renew_incl: 'Total Renew Incl txc',
                total_gov: 'Total Government excl GPI/CPI',
                total_gov_incl: 'Total Government incl GPI/CPI',
                disclaimer: {
                    title: 'Haftungsausschluss',
                    p1: 'Bitte beachten Sie: F\u00FCr jede Bestellung, bei der keine Autodesk-Partnerprovision (PPC) gilt - etwa in F\u00E4llen ohne berechtigtes Produkt, ohne Spezialisierung, mit Einschr\u00E4nkungen f\u00FCr Named Accounts oder dem Status eines Non-Nurture-Resellers - wird keine Partnerverg\u00FCtung gew\u00E4hrt.',
                    p2: 'Wir sind bestrebt, bei jeder Bestellung eine Mindestmarge/-provision sicherzustellen. In F\u00E4llen, in denen Autodesk jedoch keine Partnerverg\u00FCtung gew\u00E4hrt, kann dies nicht garantiert werden.',
                    small: 'Die Ergebnisse dieses Rechners sind unverbindlich und k\u00F6nnen von den tats\u00E4chlichen Ergebnissen abweichen. Aus diesem Hilfsmittel k\u00F6nnen keine Rechte abgeleitet werden.',
                }
            },
        };

        languages: LocationOptionViewModel[] = [
            { name: 'NL', code: 'nl', redirectUrl: '/' },
            { name: 'EN', code: 'en', redirectUrl: '/' },
            { name: 'DE', code: 'de', redirectUrl: '/' },
        ];
        selectedLanguage: Ref<LocationOptionViewModel> = ref({ name: 'NL', code: 'nl', redirectUrl: '/' });

        tiers = computed(() => [
            { name: this.texts[this.selectedLanguage.value.code]?.dropdown?.tier?.options.tier1, code: 'tier1' },
            { name: this.texts[this.selectedLanguage.value.code]?.dropdown?.tier?.options.tier2, code: 'tier2' },
            { name: this.texts[this.selectedLanguage.value.code]?.dropdown?.tier?.options.tier3, code: 'tier3' },
        ]);

        inputs = ref({
            ltFamily: 0,
            ltFamilyGr1: 0,
            ltFamilyGr2: 0,
            autocadIST: 0,
            autocadISTGr1: 0,
            autocadISTGr2: 0,
            verticals: 0,
            verticalsGr1: 0,
            verticalsGr2: 0,
            autocadIST_cloud: 0,
            autocadIST_cloudGr1: 0,
            autocadIST_cloudGr2: 0,
            verticals_cloud: 0,
            verticals_cloudGr1: 0,
            verticals_cloudGr2: 0,
            cadacIP: 0,
            cadacServices: 0,

            renew_ltFamily: 0,
            renew_ltFamilyGr1: 0,
            renew_ltFamilyGr2: 0,
            renew_autocadIST: 0,
            renew_autocadISTGr1: 0,
            renew_autocadISTGr2: 0,
            renew_verticals: 0,
            renew_verticalsGr1: 0,
            renew_verticalsGr2: 0,
            renew_cadacIP: 0,
            renew_cadacServices: 0,

            renew_incl_ltFamily: 0,
            renew_incl_ltFamilyGr1: 0,
            renew_incl_ltFamilyGr2: 0,
            renew_incl_autocadIST: 0,
            renew_incl_autocadISTGr1: 0,
            renew_incl_autocadISTGr2: 0,
            renew_incl_verticals: 0,
            renew_incl_verticalsGr1: 0,
            renew_incl_verticalsGr2: 0,
            renew_incl_cadacIP: 0,
            renew_incl_cadacServices: 0,

            gov_ltFamily: 0,
            gov_autocadIST: 0,
            gov_verticals: 0,

            gov_incl_ltFamily: 0,
            gov_incl_autocadIST: 0,
            gov_incl_verticals: 0,
        });

        // Partner kan percentage verdienen en in geval van NEW ook een transaction fee en soms een QPC fee (Met aftrek van Cadac deel)
        // Cadac verdient soms een tier-fee en de helft van de delta's bij growth1 en growth2
        // In het geval van LT en Autocad IST, pakt Cadac GEEN tier-fee bij geen enkele tier
        computedValues = {
            ltFamily: {
                ppc: computed(() => (this.inputs.value.ltFamily / 100) * this.data.ltFamily[this.selectedTier.value].ppc.percentage),
                gr1: computed(() => (this.inputs.value.ltFamilyGr1 / 100) * this.data.ltFamily[this.selectedTier.value].gr1.percentage),
                gr2: computed(() => (this.inputs.value.ltFamilyGr2 / 100) * this.data.ltFamily[this.selectedTier.value].gr2.percentage),
                fee: computed(() =>
                    (this.inputs.value.ltFamily / 100) * ((this.data.ltFamily.tier3.fee.percentage)) +
                    (this.inputs.value.ltFamilyGr1 / 100) * ((this.data.ltFamily.tier3.fee.percentage)) +
                    (this.inputs.value.ltFamilyGr2 / 100) * ((this.data.ltFamily.tier3.fee.percentage))
                ),
                cadac: computed(() =>
                    (this.inputs.value.ltFamily / 100) * (this.data.ltFamily[this.selectedTier.value].cadac.percentage) +
                    (this.inputs.value.ltFamilyGr1 / 100) * (this.data.ltFamily[this.selectedTier.value].cadac.percentage) +
                    (this.inputs.value.ltFamilyGr2 / 100) * (this.data.ltFamily[this.selectedTier.value].cadac.percentage)
                ),

                renew_ppc: computed(() => (this.inputs.value.renew_ltFamily / 100) * this.data.ltFamily[this.selectedTier.value].ppc.percentage),
                renew_gr1: computed(() => (this.inputs.value.renew_ltFamilyGr1 / 100) * this.data.ltFamily[this.selectedTier.value].gr1.percentage),
                renew_gr2: computed(() => (this.inputs.value.renew_ltFamilyGr2 / 100) * this.data.ltFamily[this.selectedTier.value].gr2.percentage),
                renew_cadac: computed(() =>  0),
                
                renew_incl_ppc: computed(() => (this.inputs.value.renew_incl_ltFamily / 100) * this.data.ltFamily[this.selectedTier.value].ppc.percentage),
                renew_incl_gr1: computed(() => (this.inputs.value.renew_incl_ltFamilyGr1 / 100) * this.data.ltFamily[this.selectedTier.value].gr1.percentage),
                renew_incl_gr2: computed(() => (this.inputs.value.renew_incl_ltFamilyGr2 / 100) * this.data.ltFamily[this.selectedTier.value].gr2.percentage),
                renew_incl_cadac: computed(() =>  0),
                renew_incl_fee: computed(() =>
                    (this.inputs.value.renew_incl_ltFamily / 100) * ((this.data.ltFamily.tier3.fee.percentage)) +
                    (this.inputs.value.renew_incl_ltFamilyGr1 / 100) * ((this.data.ltFamily.tier3.fee.percentage)) +
                    (this.inputs.value.renew_incl_ltFamilyGr2 / 100) * ((this.data.ltFamily.tier3.fee.percentage))
                ),

                gov_ppc: computed(() => (this.inputs.value.gov_ltFamily / 100) * this.data.ltFamily[this.selectedTier.value].ppc.percentage),
                gov_fee: computed(() => (this.inputs.value.gov_ltFamily / 100) * ((this.data.ltFamily.tier3.fee.percentage))),
                gov_cadac: computed(() => 0),

                gov_incl_ppc: computed(() => (this.inputs.value.gov_incl_ltFamily / 100) * this.data.ltFamily[this.selectedTier.value].ppc.percentage),
                gov_incl_cpi: computed(() => (this.inputs.value.gov_incl_ltFamily / 100) * this.data.ltFamily.tier3.cpi.percentage),
                gov_incl_fee: computed(() => (this.inputs.value.gov_incl_ltFamily / 100) * this.data.ltFamily.tier3.fee.percentage),
                gov_incl_cadac: computed(() => 0),
            },
            autocadIST: {
                ppc: computed(() => (this.inputs.value.autocadIST / 100) * (this.data.autocadIST.tier3.ppc.percentage - this.data.autocadIST[this.selectedTier.value].cadac.percentage)),
                gr1: computed(() => (this.inputs.value.autocadISTGr1 / 100) * (this.data.autocadIST.tier3.gr1.percentage - this.data.autocadIST.tier3.delta_gr1 - this.data.autocadIST[this.selectedTier.value].cadac.percentage)),
                gr2: computed(() => (this.inputs.value.autocadISTGr2 / 100) * (this.data.autocadIST.tier3.gr2.percentage - this.data.autocadIST.tier3.delta_gr2 - this.data.autocadIST[this.selectedTier.value].cadac.percentage)),
                qp: computed(() =>
                    (this.inputs.value.autocadIST / 100) * this.data.autocadIST.tier3.qp.percentage +
                    (this.inputs.value.autocadISTGr1 / 100) * this.data.autocadIST.tier3.qp.percentage +
                    (this.inputs.value.autocadISTGr2 / 100) * this.data.autocadIST.tier3.qp.percentage
                ),
                fee: computed(() =>
                    (this.inputs.value.autocadIST / 100) * this.data.autocadIST.tier3.fee.percentage +
                    (this.inputs.value.autocadISTGr1 / 100) * this.data.autocadIST.tier3.fee.percentage +
                    (this.inputs.value.autocadISTGr2 / 100) * this.data.autocadIST.tier3.fee.percentage
                ),
                cadac: computed(() =>
                    (this.inputs.value.autocadIST / 100) * (this.data.autocadIST[this.selectedTier.value].cadac.percentage) +
                    (this.inputs.value.autocadISTGr1 / 100) * (this.data.autocadIST[this.selectedTier.value].cadac.percentage + this.data.autocadIST.tier3.delta_gr1) +
                    (this.inputs.value.autocadISTGr2 / 100) * (this.data.autocadIST[this.selectedTier.value].cadac.percentage + this.data.autocadIST.tier3.delta_gr2)
                ),
                renew_ppc: computed(() => (this.inputs.value.renew_autocadIST / 100) * (this.data.autocadIST.tier3.ppc.percentage - this.data.autocadIST[this.selectedTier.value].cadac.percentage)),
                renew_gr1: computed(() => (this.inputs.value.renew_autocadISTGr1 / 100) * (this.data.autocadIST.tier3.gr1.percentage - this.data.autocadIST.tier3.delta_gr1 - this.data.autocadIST[this.selectedTier.value].cadac.percentage)),
                renew_gr2: computed(() => (this.inputs.value.renew_autocadISTGr2 / 100) * (this.data.autocadIST.tier3.gr2.percentage - this.data.autocadIST.tier3.delta_gr2 - this.data.autocadIST[this.selectedTier.value].cadac.percentage)),
                renew_cadac: computed(() =>
                    (this.inputs.value.renew_autocadIST / 100) * (this.data.autocadIST[this.selectedTier.value].cadac.percentage) +
                    (this.inputs.value.renew_autocadISTGr1 / 100) * (this.data.autocadIST[this.selectedTier.value].cadac.percentage + this.data.autocadIST.tier3.delta_gr1) +
                    (this.inputs.value.renew_autocadISTGr2 / 100) * (this.data.autocadIST[this.selectedTier.value].cadac.percentage + this.data.autocadIST.tier3.delta_gr2)
                ),

                renew_incl_ppc: computed(() => (this.inputs.value.renew_incl_autocadIST / 100) * (this.data.autocadIST.tier3.ppc.percentage - this.data.autocadIST[this.selectedTier.value].cadac.percentage)),
                renew_incl_gr1: computed(() => (this.inputs.value.renew_incl_autocadISTGr1 / 100) * (this.data.autocadIST.tier3.gr1.percentage - this.data.autocadIST.tier3.delta_gr1 - this.data.autocadIST[this.selectedTier.value].cadac.percentage)),
                renew_incl_gr2: computed(() => (this.inputs.value.renew_incl_autocadISTGr2 / 100) * (this.data.autocadIST.tier3.gr2.percentage - this.data.autocadIST.tier3.delta_gr2 - this.data.autocadIST[this.selectedTier.value].cadac.percentage)),
                renew_incl_cadac: computed(() =>
                    (this.inputs.value.renew_incl_autocadIST / 100) * (this.data.autocadIST[this.selectedTier.value].cadac.percentage) +
                    (this.inputs.value.renew_incl_autocadISTGr1 / 100) * (this.data.autocadIST[this.selectedTier.value].cadac.percentage + this.data.autocadIST.tier3.delta_gr1) +
                    (this.inputs.value.renew_incl_autocadISTGr2 / 100) * (this.data.autocadIST[this.selectedTier.value].cadac.percentage + this.data.autocadIST.tier3.delta_gr2)
                ),
                renew_incl_fee: computed(() =>
                    (this.inputs.value.renew_incl_autocadIST / 100) * this.data.autocadIST.tier3.fee.percentage +
                    (this.inputs.value.renew_incl_autocadISTGr1 / 100) * this.data.autocadIST.tier3.fee.percentage +
                    (this.inputs.value.renew_incl_autocadISTGr2 / 100) * this.data.autocadIST.tier3.fee.percentage
                ),

                gov_ppc: computed(() => (this.inputs.value.gov_autocadIST / 100) * (this.data.autocadIST.tier3.ppc.percentage - this.data.autocadIST[this.selectedTier.value].cadac.percentage)),
                gov_fee: computed(() => (this.inputs.value.gov_autocadIST / 100) * this.data.autocadIST.tier3.fee.percentage),
                gov_cadac: computed(() => (this.inputs.value.gov_autocadIST / 100) * this.data.autocadIST[this.selectedTier.value].cadac.percentage),

                gov_incl_ppc: computed(() => (this.inputs.value.gov_incl_autocadIST / 100) * (this.data.autocadIST.tier3.ppc.percentage - this.data.autocadIST[this.selectedTier.value].cadac.percentage)),
                gov_incl_cpi: computed(() => (this.inputs.value.gov_incl_autocadIST / 100) * this.data.autocadIST.tier3.cpi.percentage),
                gov_incl_fee: computed(() => (this.inputs.value.gov_incl_autocadIST / 100) * this.data.autocadIST.tier3.fee.percentage),
                gov_incl_cadac: computed(() => (this.inputs.value.gov_incl_autocadIST / 100) * this.data.autocadIST[this.selectedTier.value].cadac.percentage),
            },
            autocadIST_cloud: {
                ppc: computed(() => (this.inputs.value.autocadIST_cloud / 100) * (this.data.autocadIST_cloud.tier3.ppc.percentage - this.data.autocadIST_cloud[this.selectedTier.value].cadac.percentage)),
                gr1: computed(() => (this.inputs.value.autocadIST_cloudGr1 / 100) * (this.data.autocadIST_cloud.tier3.gr1.percentage - this.data.autocadIST_cloud.tier3.delta_gr1 - this.data.autocadIST_cloud[this.selectedTier.value].cadac.percentage)),
                gr2: computed(() => (this.inputs.value.autocadIST_cloudGr2 / 100) * (this.data.autocadIST_cloud.tier3.gr2.percentage - this.data.autocadIST_cloud.tier3.delta_gr2 - this.data.autocadIST_cloud[this.selectedTier.value].cadac.percentage)),
                qp: computed(() =>
                    (this.inputs.value.autocadIST_cloud / 100) * this.data.autocadIST_cloud.tier3.qp.percentage +
                    (this.inputs.value.autocadIST_cloudGr1 / 100) * this.data.autocadIST_cloud.tier3.qp.percentage +
                    (this.inputs.value.autocadIST_cloudGr2 / 100) * this.data.autocadIST_cloud.tier3.qp.percentage
                ),
                fee: computed(() =>
                    (this.inputs.value.autocadIST_cloud / 100) * this.data.autocadIST_cloud.tier3.fee.percentage +
                    (this.inputs.value.autocadIST_cloudGr1 / 100) * this.data.autocadIST_cloud.tier3.fee.percentage +
                    (this.inputs.value.autocadIST_cloudGr2 / 100) * this.data.autocadIST_cloud.tier3.fee.percentage
                ),
                cadac: computed(() =>
                    (this.inputs.value.autocadIST_cloud / 100) * (this.data.autocadIST_cloud[this.selectedTier.value].cadac.percentage) +
                    (this.inputs.value.autocadIST_cloudGr1 / 100) * (this.data.autocadIST_cloud[this.selectedTier.value].cadac.percentage + this.data.autocadIST_cloud.tier3.delta_gr1) +
                    (this.inputs.value.autocadIST_cloudGr2 / 100) * (this.data.autocadIST_cloud[this.selectedTier.value].cadac.percentage + this.data.autocadIST_cloud.tier3.delta_gr2)
                ),
            },
            verticals: {
                ppc: computed(() => (this.inputs.value.verticals / 100) * (this.data.verticals.tier3.ppc.percentage - this.data.verticals[this.selectedTier.value].cadac.percentage)),
                gr1: computed(() => (this.inputs.value.verticalsGr1 / 100) * (this.data.verticals.tier3.gr1.percentage - this.data.verticals.tier3.delta_gr1 - this.data.verticals[this.selectedTier.value].cadac.percentage)),
                gr2: computed(() => (this.inputs.value.verticalsGr2 / 100) * (this.data.verticals.tier3.gr2.percentage - this.data.verticals.tier3.delta_gr2 - this.data.verticals[this.selectedTier.value].cadac.percentage)),
                qp: computed(() =>
                    (this.inputs.value.verticals / 100) * this.data.verticals.tier3.qp.percentage +
                    (this.inputs.value.verticalsGr1 / 100) * this.data.verticals.tier3.qp.percentage +
                    (this.inputs.value.verticalsGr2 / 100) * this.data.verticals.tier3.qp.percentage
                ),
                fee: computed(() =>
                    (this.inputs.value.verticals / 100) * this.data.verticals.tier3.fee.percentage +
                    (this.inputs.value.verticalsGr1 / 100) * this.data.verticals.tier3.fee.percentage +
                    (this.inputs.value.verticalsGr2 / 100) * this.data.verticals.tier3.fee.percentage
                ),
                cadac: computed(() =>
                    (this.inputs.value.verticals / 100) * (this.data.verticals[this.selectedTier.value].cadac.percentage) +
                    (this.inputs.value.verticalsGr1 / 100) * (this.data.verticals[this.selectedTier.value].cadac.percentage + this.data.verticals.tier3.delta_gr1) +
                    (this.inputs.value.verticalsGr2 / 100) * (this.data.verticals[this.selectedTier.value].cadac.percentage + this.data.verticals.tier3.delta_gr2)
                ),

                renew_ppc: computed(() => (this.inputs.value.renew_verticals / 100) * (this.data.verticals.tier3.ppc.percentage - this.data.verticals[this.selectedTier.value].cadac.percentage)),
                renew_gr1: computed(() => (this.inputs.value.renew_verticalsGr1 / 100) * (this.data.verticals.tier3.gr1.percentage - this.data.verticals.tier3.delta_gr1 - this.data.verticals[this.selectedTier.value].cadac.percentage)),
                renew_gr2: computed(() => (this.inputs.value.renew_verticalsGr2 / 100) * (this.data.verticals.tier3.gr2.percentage - this.data.verticals.tier3.delta_gr2 - this.data.verticals[this.selectedTier.value].cadac.percentage)),   
                renew_cadac: computed(() =>
                    (this.inputs.value.renew_verticals / 100) * (this.data.verticals[this.selectedTier.value].cadac.percentage) +
                    (this.inputs.value.renew_verticalsGr1 / 100) * (this.data.verticals[this.selectedTier.value].cadac.percentage + this.data.verticals.tier3.delta_gr1) +
                    (this.inputs.value.renew_verticalsGr2 / 100) * (this.data.verticals[this.selectedTier.value].cadac.percentage + this.data.verticals.tier3.delta_gr2)
                ),

                renew_incl_ppc: computed(() => (this.inputs.value.renew_incl_verticals / 100) * (this.data.verticals.tier3.ppc.percentage - this.data.verticals[this.selectedTier.value].cadac.percentage)),
                renew_incl_gr1: computed(() => (this.inputs.value.renew_incl_verticalsGr1 / 100) * (this.data.verticals.tier3.gr1.percentage - this.data.verticals.tier3.delta_gr1 - this.data.verticals[this.selectedTier.value].cadac.percentage)),
                renew_incl_gr2: computed(() => (this.inputs.value.renew_incl_verticalsGr2 / 100) * (this.data.verticals.tier3.gr2.percentage - this.data.verticals.tier3.delta_gr2 - this.data.verticals[this.selectedTier.value].cadac.percentage)),
                renew_incl_cadac: computed(() =>
                    (this.inputs.value.renew_incl_verticals / 100) * (this.data.verticals[this.selectedTier.value].cadac.percentage) +
                    (this.inputs.value.renew_incl_verticalsGr1 / 100) * (this.data.verticals[this.selectedTier.value].cadac.percentage + this.data.verticals.tier3.delta_gr1) +
                    (this.inputs.value.renew_incl_verticalsGr2 / 100) * (this.data.verticals[this.selectedTier.value].cadac.percentage + this.data.verticals.tier3.delta_gr2)
                ),
                renew_incl_fee: computed(() =>
                    (this.inputs.value.renew_incl_verticals / 100) * this.data.verticals.tier3.fee.percentage +
                    (this.inputs.value.renew_incl_verticalsGr1 / 100) * this.data.verticals.tier3.fee.percentage +
                    (this.inputs.value.renew_incl_verticalsGr2 / 100) * this.data.verticals.tier3.fee.percentage
                ),
                gov_ppc: computed(() => (this.inputs.value.gov_verticals / 100) * (this.data.verticals.tier3.ppc.percentage - this.data.verticals[this.selectedTier.value].cadac.percentage)),
                gov_fee: computed(() => (this.inputs.value.gov_verticals / 100) * this.data.verticals.tier3.fee.percentage),
                gov_cadac: computed(() => (this.inputs.value.gov_verticals / 100) * this.data.verticals[this.selectedTier.value].cadac.percentage),

                gov_incl_ppc: computed(() => (this.inputs.value.gov_incl_verticals / 100) * (this.data.verticals.tier3.ppc.percentage - this.data.verticals[this.selectedTier.value].cadac.percentage)),
                gov_incl_cpi: computed(() => (this.inputs.value.gov_incl_verticals / 100) * this.data.verticals.tier3.cpi.percentage),
                gov_incl_fee: computed(() => (this.inputs.value.gov_incl_verticals / 100) * this.data.verticals.tier3.fee.percentage),
                gov_incl_cadac: computed(() => (this.inputs.value.gov_incl_verticals / 100) * this.data.verticals[this.selectedTier.value].cadac.percentage),
            },
            verticals_cloud: {
                ppc: computed(() => (this.inputs.value.verticals_cloud / 100) * (this.data.verticals_cloud.tier3.ppc.percentage - this.data.verticals_cloud[this.selectedTier.value].cadac.percentage)),
                gr1: computed(() => (this.inputs.value.verticals_cloudGr1 / 100) * (this.data.verticals_cloud.tier3.gr1.percentage - this.data.verticals_cloud.tier3.delta_gr1 - this.data.verticals_cloud[this.selectedTier.value].cadac.percentage)),
                gr2: computed(() => (this.inputs.value.verticals_cloudGr2 / 100) * (this.data.verticals_cloud.tier3.gr2.percentage - this.data.verticals_cloud.tier3.delta_gr2 - this.data.verticals_cloud[this.selectedTier.value].cadac.percentage)),
                qp: computed(() => 
                    (this.inputs.value.verticals_cloud / 100) * this.data.verticals_cloud.tier3.qp.percentage +
                    (this.inputs.value.verticals_cloudGr1 / 100) * this.data.verticals_cloud.tier3.qp.percentage +
                    (this.inputs.value.verticals_cloudGr2 / 100) * this.data.verticals_cloud.tier3.qp.percentage
                ),
                fee: computed(() => 
                    (this.inputs.value.verticals_cloud / 100) * this.data.verticals_cloud.tier3.fee.percentage +
                    (this.inputs.value.verticals_cloudGr1 / 100) * this.data.verticals_cloud.tier3.fee.percentage +
                    (this.inputs.value.verticals_cloudGr2 / 100) * this.data.verticals_cloud.tier3.fee.percentage
                ),
                cadac: computed(() =>
                    (this.inputs.value.verticals_cloud / 100) * (this.data.verticals_cloud[this.selectedTier.value].cadac.percentage) +
                    (this.inputs.value.verticals_cloudGr1 / 100) * (this.data.verticals_cloud[this.selectedTier.value].cadac.percentage + this.data.verticals_cloud.tier3.delta_gr1) +
                    (this.inputs.value.verticals_cloudGr2 / 100) * (this.data.verticals_cloud[this.selectedTier.value].cadac.percentage + this.data.verticals_cloud.tier3.delta_gr2)
                ),
            },
            cadacIP: {
                ppc: computed(() => (this.inputs.value.cadacIP / 100) * this.data.cadacIP.tier3.ppc.percentage),
                cadac: computed(() => (this.inputs.value.cadacIP / 100) * this.data.cadacIP.tier3.cadac.percentage),

                renew_ppc: computed(() => (this.inputs.value.renew_cadacIP / 100) * this.data.cadacIP.tier3.ppc.percentage),
                renew_cadac: computed(() => (this.inputs.value.renew_cadacIP / 100) * this.data.cadacIP.tier3.cadac.percentage),

                renew_incl_ppc: computed(() => (this.inputs.value.renew_incl_cadacIP / 100) * this.data.cadacIP.tier3.ppc.percentage),
                renew_incl_cadac: computed(() => (this.inputs.value.renew_incl_cadacIP / 100) * this.data.cadacIP.tier3.cadac.percentage),
            },
            cadacServices: {
                ppc: computed(() => (this.inputs.value.cadacServices / 100) * this.data.cadacServices.tier3.ppc.percentage),
                cadac: computed(() => (this.inputs.value.cadacServices / 100) * this.data.cadacServices.tier3.cadac.percentage),

                renew_ppc: computed(() => (this.inputs.value.renew_cadacServices / 100) * this.data.cadacServices.tier3.ppc.percentage),
                renew_cadac: computed(() => (this.inputs.value.renew_cadacServices / 100) * this.data.cadacServices.tier3.cadac.percentage),

                renew_incl_ppc: computed(() => (this.inputs.value.renew_incl_cadacServices / 100) * this.data.cadacServices.tier3.ppc.percentage),
                renew_incl_cadac: computed(() => (this.inputs.value.renew_incl_cadacServices / 100) * this.data.cadacServices.tier3.cadac.percentage),
            },
            totalRevenue: computed(() => this.inputs.value.ltFamily + this.inputs.value.autocadIST + this.inputs.value.autocadIST_cloud + this.inputs.value.verticals + this.inputs.value.verticals_cloud + this.inputs.value.cadacIP + this.inputs.value.cadacServices),
            totalRevenueGr1: computed(() => this.inputs.value.ltFamilyGr1 + this.inputs.value.autocadISTGr1 + this.inputs.value.autocadIST_cloudGr1 + this.inputs.value.verticalsGr1 + this.inputs.value.verticals_cloudGr1),
            totalRevenueGr2: computed(() => this.inputs.value.ltFamilyGr2 + this.inputs.value.autocadISTGr2 + this.inputs.value.autocadIST_cloudGr2 + this.inputs.value.verticalsGr2 + this.inputs.value.verticals_cloudGr2),

            renew_totalRevenue: computed(() => this.inputs.value.renew_ltFamily + this.inputs.value.renew_autocadIST + this.inputs.value.renew_verticals + this.inputs.value.renew_cadacIP + this.inputs.value.renew_cadacServices),
            renew_totalRevenueGr1: computed(() => this.inputs.value.renew_ltFamilyGr1 + this.inputs.value.renew_autocadISTGr1 + this.inputs.value.renew_verticalsGr1),
            renew_totalRevenueGr2: computed(() => this.inputs.value.renew_ltFamilyGr2 + this.inputs.value.renew_autocadISTGr2 + this.inputs.value.renew_verticalsGr2),

            renew_incl_totalRevenue: computed(() => this.inputs.value.renew_incl_ltFamily + this.inputs.value.renew_incl_autocadIST + this.inputs.value.renew_incl_verticals + this.inputs.value.renew_incl_cadacIP + this.inputs.value.renew_incl_cadacServices),
            renew_incl_totalRevenueGr1: computed(() => this.inputs.value.renew_incl_ltFamilyGr1 + this.inputs.value.renew_incl_autocadISTGr1 + this.inputs.value.renew_incl_verticalsGr1),
            renew_incl_totalRevenueGr2: computed(() => this.inputs.value.renew_incl_ltFamilyGr2 + this.inputs.value.renew_incl_autocadISTGr2 + this.inputs.value.renew_incl_verticalsGr2),

            gov_totalRevenue: computed(() => this.inputs.value.gov_ltFamily + this.inputs.value.gov_autocadIST + this.inputs.value.gov_verticals),
            gov_incl_totalRevenue: computed(() => this.inputs.value.gov_incl_ltFamily + this.inputs.value.gov_incl_autocadIST + this.inputs.value.gov_incl_verticals),
        };

        totals = {
            totalPpc: computed(() => this.computedValues.ltFamily.ppc.value + this.computedValues.autocadIST.ppc.value + this.computedValues.autocadIST_cloud.ppc.value + this.computedValues.verticals.ppc.value + this.computedValues.verticals_cloud.ppc.value + this.computedValues.cadacIP.ppc.value + this.computedValues.cadacServices.ppc.value),
            totalGr1: computed(() => this.computedValues.ltFamily.gr1.value + this.computedValues.autocadIST.gr1.value + this.computedValues.autocadIST_cloud.gr1.value + this.computedValues.verticals.gr1.value + this.computedValues.verticals_cloud.gr1.value),
            totalGr2: computed(() => this.computedValues.ltFamily.gr2.value + this.computedValues.autocadIST.gr2.value + this.computedValues.autocadIST_cloud.gr2.value + this.computedValues.verticals.gr2.value + this.computedValues.verticals_cloud.gr2.value),
            totalQP: computed(() => this.computedValues.autocadIST.qp.value + this.computedValues.autocadIST_cloud.qp.value + this.computedValues.verticals.qp.value + this.computedValues.verticals_cloud.qp.value),
            totalFee: computed(() => this.computedValues.ltFamily.fee.value + this.computedValues.autocadIST.fee.value + this.computedValues.autocadIST_cloud.fee.value + this.computedValues.verticals.fee.value + this.computedValues.verticals_cloud.fee.value ),
            totalCadac: computed(() => this.computedValues.ltFamily.cadac.value + this.computedValues.autocadIST.cadac.value + this.computedValues.autocadIST_cloud.cadac.value + this.computedValues.verticals.cadac.value + this.computedValues.verticals_cloud.cadac.value + this.computedValues.cadacIP.cadac.value + this.computedValues.cadacServices.cadac.value),

            renew_totalPpc: computed(() => this.computedValues.ltFamily.renew_ppc.value + this.computedValues.autocadIST.renew_ppc.value + this.computedValues.verticals.renew_ppc.value + this.computedValues.cadacIP.renew_ppc.value + this.computedValues.cadacServices.renew_ppc.value),
            renew_totalGr1: computed(() => this.computedValues.ltFamily.renew_gr1.value + this.computedValues.autocadIST.renew_gr1.value + this.computedValues.verticals.renew_gr1.value),
            renew_totalGr2: computed(() => this.computedValues.ltFamily.renew_gr2.value + this.computedValues.autocadIST.renew_gr2.value + this.computedValues.verticals.renew_gr2.value),
            renew_totalCadac: computed(() => this.computedValues.ltFamily.renew_cadac.value + this.computedValues.autocadIST.renew_cadac.value + this.computedValues.verticals.renew_cadac.value + this.computedValues.cadacIP.renew_cadac.value + this.computedValues.cadacServices.renew_cadac.value),
        
            renew_incl_totalPpc: computed(() => this.computedValues.ltFamily.renew_incl_ppc.value + this.computedValues.autocadIST.renew_incl_ppc.value + this.computedValues.verticals.renew_incl_ppc.value + this.computedValues.cadacIP.renew_incl_ppc.value + this.computedValues.cadacServices.renew_incl_ppc.value),
            renew_incl_totalGr1: computed(() => this.computedValues.ltFamily.renew_incl_gr1.value + this.computedValues.autocadIST.renew_incl_gr1.value + this.computedValues.verticals.renew_incl_gr1.value),
            renew_incl_totalGr2: computed(() => this.computedValues.ltFamily.renew_incl_gr2.value + this.computedValues.autocadIST.renew_incl_gr2.value + this.computedValues.verticals.renew_incl_gr2.value),
            renew_incl_totalFee: computed(() => this.computedValues.ltFamily.renew_incl_fee.value + this.computedValues.autocadIST.renew_incl_fee.value + this.computedValues.verticals.renew_incl_fee.value),
            renew_incl_totalCadac: computed(() => this.computedValues.ltFamily.renew_incl_cadac.value + this.computedValues.autocadIST.renew_incl_cadac.value + this.computedValues.verticals.renew_incl_cadac.value + this.computedValues.cadacIP.renew_incl_cadac.value + this.computedValues.cadacServices.renew_incl_cadac.value),

            gov_totalPpc: computed(() => this.computedValues.ltFamily.gov_ppc.value + this.computedValues.autocadIST.gov_ppc.value + this.computedValues.verticals.gov_ppc.value),
            gov_totalFee: computed(() => this.computedValues.ltFamily.gov_fee.value + this.computedValues.autocadIST.gov_fee.value + this.computedValues.verticals.gov_fee.value),
            gov_totalCadac: computed(() => this.computedValues.ltFamily.gov_cadac.value + this.computedValues.autocadIST.gov_cadac.value + this.computedValues.verticals.gov_cadac.value),
        
            gov_incl_totalPpc: computed(() => this.computedValues.ltFamily.gov_incl_ppc.value + this.computedValues.autocadIST.gov_incl_ppc.value + this.computedValues.verticals.gov_incl_ppc.value),
            gov_incl_totalCpi: computed(() => this.computedValues.ltFamily.gov_incl_cpi.value + this.computedValues.autocadIST.gov_incl_cpi.value + this.computedValues.verticals.gov_incl_cpi.value),
            gov_incl_totalFee: computed(() => this.computedValues.ltFamily.gov_incl_fee.value + this.computedValues.autocadIST.gov_incl_fee.value + this.computedValues.verticals.gov_incl_fee.value),
            gov_incl_totalCadac: computed(() => this.computedValues.ltFamily.gov_incl_cadac.value + this.computedValues.autocadIST.gov_incl_cadac.value + this.computedValues.verticals.gov_incl_cadac.value),

        }

        combinedTotals = {
            combined_totalRevenue: computed(() => this.computedValues.totalRevenue.value + this.computedValues.renew_totalRevenue.value + this.computedValues.renew_incl_totalRevenue.value + this.computedValues.gov_totalRevenue.value + this.computedValues.gov_incl_totalRevenue.value),
            combined_totalRevenueGr1: computed(() => this.computedValues.totalRevenueGr1.value + this.computedValues.renew_totalRevenueGr1.value + this.computedValues.renew_incl_totalRevenueGr1.value),
            combined_totalRevenueGr2: computed(() => this.computedValues.totalRevenueGr2.value + this.computedValues.renew_totalRevenueGr2.value + this.computedValues.renew_incl_totalRevenueGr2.value),
            combined_totalPpc: computed(() => this.totals.totalPpc.value + this.totals.renew_totalPpc.value + this.totals.renew_incl_totalPpc.value + this.totals.gov_totalPpc.value + this.totals.gov_incl_totalPpc.value),
            combined_totalGr1: computed(() => this.totals.totalGr1.value + this.totals.renew_totalGr1.value + this.totals.renew_incl_totalGr1.value),
            combined_totalGr2: computed(() => this.totals.totalGr2.value + this.totals.renew_totalGr2.value + this.totals.renew_incl_totalGr2.value),
            combined_totalCpi: computed(() => this.totals.gov_incl_totalCpi.value),
            combined_totalQP: computed(() => this.totals.totalQP.value),
            combined_totalFee: computed(() => this.totals.totalFee.value + this.totals.renew_incl_totalFee.value + this.totals.gov_totalFee.value + this.totals.gov_incl_totalFee.value),
            combined_totalCadac: computed(() => this.totals.totalCadac.value + this.totals.renew_totalCadac.value + this.totals.renew_incl_totalCadac.value + this.totals.gov_totalCadac.value + this.totals.gov_incl_totalCadac.value),
        }

        data = {
            ltFamily: {
                name: 'LT Family',
                tier1: {
                    ppc: {
                        percentage: 2,
                    },
                    gr1: {
                        percentage: 2,
                    },
                    gr2: {
                        percentage: 2,
                    },
                    cadac: {
                        percentage: 0, // 4
                    },
                },
                tier2: {
                    ppc: {
                        percentage: 2,
                        
                    },
                    gr1: {
                        percentage: 2,
                       
                    },
                    gr2: {
                        percentage: 2,
                        
                    },
                    cadac: {
                        percentage: 0, // 3
                    },
                },
                tier3: {
                    ppc: {
                        percentage: 2,
                       
                    },
                    gr1: {
                        percentage: 2,
                        
                    },
                    gr2: {
                        percentage: 2,
                        
                    },
                    cpi: {
                        percentage: 3,
                    },
                    fee: {
                        percentage: 5,
                    },
                    cadac: {
                        percentage: 0, // 2
                    },
                },
            },
            autocadIST: {
                renew_name: 'AutoCAD IST',
                name: 'AutoCAD IST - Subscription NEW',
                revenue: 0,
                tier1: {
                    cadac: {
                        percentage: 0, // 4
                    },
                },
                tier2: {
                    cadac: { // tier %
                        percentage: 0, // 3
                    },
                },
                tier3: {
                    ppc: {
                        percentage: 6, // 6 - tier% 2
                    },
                    gr1: {
                        percentage: 15, //15, // 15 - 6.5 (9 / 2 = 4.5)
                    },
                    gr2: {
                        percentage: 25, // 25 - 11.5 (19 / 2 = 9.5 - tier% 2)
                    },
                    cpi: {
                        percentage: 11,
                    },
                    fee: {
                        percentage: 5,
                    },
                    qp: {
                        percentage: 15,
                    },
                    delta_gr1: 4.5, // 15 - 6 = 9 /2 = 4.5
                    delta_gr2: 9.5, // 25 - 6 = 19 /2 = 9.5
                    cadac: {
                        percentage: 0, // 2
                    },
                },
            },
            autocadIST_cloud: {
                name: 'AutoCAD IST - Cloud New',
                revenue: 0,
                tier1: {
                    cadac: {
                        percentage: 0, // 4
                    },
                },
                tier2: {
                    cadac: { // tier %
                        percentage: 0, // 3
                    },
                },
                tier3: {
                    ppc: {
                        percentage: 6, // 6 - tier% 2
                    },
                    gr1: {
                        percentage: 15, //15, // 15 - 6.5 (9 / 2 = 4.5 - tier% 2)
                    },
                    gr2: {
                        percentage: 25, // 25 - 11.5 (19 / 2 = 9.5 - tier% 2)
                    },
                    fee: {
                        percentage: 5,
                    },
                    qp: {
                        percentage: 25,
                    },
                    delta_gr1: 4.5, // 15 - 6 = 9 /2 = 4.5
                    delta_gr2: 9.5, // 25 - 6 = 19 /2 = 9.5
                    cadac: {
                        percentage: 0, // 2
                    },
                },
            },
            verticals: {
                renew_name: 'Verticals',
                name: 'Verticals - Subscription New',
                revenue: 0,
                tier1: {
                    cadac: {
                        percentage: 4,
                    },
                },
                tier2: {
                    cadac: {
                        percentage: 3,
                    },
                },
                tier3: {
                    ppc: {
                        percentage: 16,
                    },
                    gr1: {
                        percentage: 27,
                    },
                    gr2: {
                        percentage: 37,
                    },
                    cpi: {
                        percentage: 24,
                    },
                    fee: {
                        percentage: 5,
                    },
                    qp: {
                        percentage: 15,
                    },
                    delta_gr1: 5.5, // 27 - 16 = 11 /2 = 5.5
                    delta_gr2: 10.5, // 37 - 16 = 21 /2 = 10.5
                    cadac: {
                        percentage: 2,
                    },
                },
            },
            verticals_cloud: {
                name: 'Verticals - Cloud New',
                revenue: 0,
                tier1: {
                    cadac: {
                        percentage: 4,
                    },
                },
                tier2: {
                    cadac: {
                        percentage: 3,
                    },
                },
                tier3: {
                    ppc: {
                        percentage: 16,
                    },
                    gr1: {
                        percentage: 27,
                    },
                    gr2: {
                        percentage: 37,
                    },
                    fee: {
                        percentage: 5,
                    },
                    qp: {
                        percentage: 25,
                    },
                    delta_gr1: 5.5, // 27 - 16 = 11 /2 = 5.5
                    delta_gr2: 10.5, // 37 - 16 = 21 /2 = 10.5
                    cadac: {
                        percentage: 2,
                    },
                },
            },
            cadacIP: {
                name: 'Cadac IP',
                revenue: 0,
                tier3: {
                    ppc: {
                        percentage: 37.5,
                    },
                    gr1: {
                        percentage: 0,
                    },
                    gr2: {
                        percentage: 0,
                    },
                    fee: {
                        percentage: 5,
                    },
                    cadac: {
                        percentage: 37.5,
                    },
                },
            },
            cadacServices: {
                name: 'Cadac Services',
                revenue: 0,
                tier3: {
                    ppc: {
                        percentage: (43.75 / 162.5) * 100,
                    },
                    gr1: {
                        percentage: 0,
                    },
                    gr2: {
                        percentage: 0,
                    },
                    fee: {
                        percentage: 5,
                    },
                    cadac: {
                        percentage: (43.75 / 162.5) * 100,
                    },
                },
            },
        };
    }

</script>

<style scoped lang="scss">
    .container {
        padding: 2rem 1rem;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 0.5rem;
        box-shadow: 0 0.125rem 0.75rem rgba(0, 0, 0, 0.05);
        max-width: 1600px;
    }

    h1 {
        font-size: 1.875rem;
        color: #2c3e50;
        text-align: center;
    }

    form {
        display: flex;
        flex-wrap: wrap;
        gap: 2rem;
        justify-content: space-between;
    }

    :deep(.p-inputnumber-input) {
        min-width: 100px;
    }

    /* SECTION BLOKKEN MET GELIJKE BREEDTE */
    section {
        flex: 1 1 45%;
        display: flex;
        flex-direction: column;
        background-color: #fafafa;
        border: 1px solid #eee;
        border-radius: 0.5rem;
        padding: 1.5rem;
        box-sizing: border-box;
        min-width: 320px;
        /* Zorg voor visueel consistente hoogte indien gewenst */
        @media (min-width: 992px) {
            min-height: 100%;
        }
    }

    .section-title {
        font-size: 1.25rem;
        color: #91004b;
        border-left: 4px solid #91004b;
        padding-left: 0.5rem;
        margin-bottom: 1.5rem;
        font-weight: 600;
    }

    th, td {
        font-weight: 800;
    }

    th span {
        font-weight: 400;
        font-style: italic;
        min-height: 1.5em;
        display: block;
    }

    /* FORMGROUP STRUCTUUR */
    .form-group {
        display: flex;
        flex-direction: column;
        margin-bottom: 1.25rem;

        label {
            font-weight: 500;
            margin-bottom: 0.5rem;
            color: #444;
        }

        input,
        textarea {
            padding: 0.75rem 1rem;
            font-size: 1rem;
            border: 1px solid #ccc;
            border-radius: 0.375rem;
            transition: border-color 0.3s ease, box-shadow 0.3s ease;
        }

        input:focus,
        textarea:focus {
            border-color: #91004b;
            box-shadow: 0 0 0 3px rgba(145, 0, 75, 0.15);
            outline: none;
        }

        textarea {
            resize: vertical;
            min-height: 6rem;
        }
    }

    /* BUTTONS ONDERAAN */
    .form-actions {
        width: 100%;
        margin-top: 2rem;
        display: flex;
        justify-content: flex-end;

        button[type="submit"] {
            background-color: #91004b;
            color: white;
            padding: 0.75rem 2rem;
            font-size: 1rem;
            font-weight: 600;
            border: none;
            border-radius: 0.375rem;
            cursor: pointer;
            transition: background-color 0.3s ease;

            &:hover {
                background-color: #c91254;
            }
        }
    }

    /* MOBIEL RESPONSIVITEIT */
    @media (max-width: 768px) {
        form {
            flex-direction: column;
        }

        section {
            width: 100%;
        }
    }

    .language-menu {
        border: none;
        width: auto;

        .flag-icon {
            margin: 0.35rem 0;
        }
    }

    .header-container {
        min-height: 200px;
        background-position: left;
        background-repeat: no-repeat;
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
        padding: 1rem;
        position: relative;
        gap: 1rem;

        .center-text {
            grid-column: 2; /* middenkolom */
            text-align: center;
            margin: 0;
            white-space: nowrap;
        }
    }

    .language-wrapper {
        grid-column: 3; /* rechterkolom */
        justify-self: end;
    }

/*    //.header-image-container {
    //    overflow: hidden;
    //}*/

/*    //.header-image {
    //    max-width: 1166px;
    //}*/

    small {
        font-style: italic;
    }

    .highlight {
        background-color: #91004b;
        border-radius: 3px;
    }

    .label-inputswitch-lineheight {
        line-height: 1.5em;
        min-height: calc(1.5em * 2);
    }
    .border-top {
        border-top: 2px solid black !important;
    }
</style>